import firebase from 'firebase/app'
import 'firebase/auth'
import * as env_config from '../config/config.json'

if (!firebase.apps.length) {
    firebase.initializeApp(env_config['firebase_config']);
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
}

export default firebase;


// WEBPACK FOOTER //
// ./src/components/Firebase.js